<template>
  <div
    class="checkbox"
    :class="classes"
    :style="styles"
  >
    <input
      :id="id"
      ref="check"
      type="checkbox"
      :name="id"
      :value="id"
      :checked="localValue"
      :aria-checked="localValue"
      v-model="localValue"
    >

    <label
      :for="id"
      class="checkbox-label"
    >
      <span><slot/></span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'VCheckbox',
  data() {
    return {
      localValue: this.value
    }
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    value: {},
    round: Boolean,
    left: {
      type: Boolean,
      default: true
    },
    right: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'secondary',
    },
    checkedColor: {
      type: String,
      default: 'secondary',
    },
  },
  computed: {
    classes() {
      return {
        'checkbox-left': this.left && !this.right,
        'checkbox-right': this.right,
        pill: this.round
      }
    },
    styles() {
      return {
      '--vx-check-color': !!this.color ? ' var(--vx-' + this.color + ') ' : '',
      '--vx-check-checked': !!this.checkedColor ? ' var(--vx-' + this.checkedColor + ')' : '',
      }
    },
  },
  watch: {
    localValue(value) {
      this.$emit('input', value)
    },
    value(value) {
      this.localValue = value
    }
  },
};
</script>

<style lang="scss">
@import "VCheckbox";
</style>
